// @flow
export const SET_PRIVATE_ROUTE = 'SET_PRIVATE_ROUTE';
export const SET_LOADING_APPOINTMENT =
  'userInteractions/SET_LOADING_APPOINTMENT';

// pageAppointment
export const SET_APPOINTMENT_FILTER_DAYS_BY = 'SET_APPOINTMENT_FILTER_DAYS_BY';
export const SET_APPOINTMENT_SELECTED_DAY = 'SET_APPOINTMENT_SELECTED_DAY';
export const CLEAR_APPOINTMENT_SELECTED_DAY = 'CLEAR_APPOINTMENT_SELECTED_DAY';
export const SET_GTM_FIRST_AVAILABLE_TIMESLOT =
  'SET_GTM_FIRST_AVAILABLE_TIMESLOT';
export const SET_NO_LONGER_AVAILABLE_DATE = 'SET_NO_LONGER_AVAILABLE_DATE';
export const SET_LAST_TIMESLOT_SELECTED = 'SET_LAST_TIMESLOT_SELECTED';
export const SELECTED_TIMESLOT_IN_PROMO_RANGE =
  'SELECTED_TIMESLOT_IN_PROMO_RANGE';
// pageVehicle
export const SET_NO_FINDS_ALERT_SHOWN = 'SET_NO_FINDS_ALERT_SHOWN';
export const SET_TRIMS_SELECTED_POSITION = 'SET_TRIMS_SELECTED_POSITION';
export const SET_IDK_SELECTED = 'SET_IDK_SELECTED';
export const SET_SHOW_MOBILE_FOOTER = 'SET_SHOW_MOBILE_FOOTER';
export const SET_VEHICLE_PAGE_REVISIT = 'SET_VEHICLE_PAGE_REVISIT';

// application Flow
export const SET_APP_FLOW = 'SET_APP_FLOW';

export const SET_APP_NAME = 'SET_APP_NAME';

// Modify
export const SET_MODIFY_ENABLED = 'SET_MODIFY_ENABLED';
export const SET_APPT_MODIFIED = 'SET_HAS MODIFIED';

// GTM
export const SET_START_EVENT_SENT = 'SET_START_EVENT_SENT';

// pageReview
export const SET_CONTACT_INFO_MISSING = 'SET_CONTACT_INFO_MISSING';
export const SET_POPULATE_MOBILE_PHONE_NUMBER =
  'SET_POPULATE_MOBILE_PHONE_NUMBER';
export const SET_CONTACT_INFO_FORM_VALID = 'SET_CONTACT_INFO_FORM_VALID';
export const SET_MOBILE_NUMBER_MODIFIED = 'SET_MOBILE_NUMBER_MODIFIED';

// Find me
export const SET_SEARCH_CRITERIA_FIND_ME = 'SET_SEARCH_CRITERIA_FIND_ME';

// Self Check In
export const SET_SELF_CHECK_IN_ENABLED = 'SET_SELF_CHECK_IN_ENABLED';
export const SET_SELF_CHECK_IN_EXTENDED_ENABLED =
  'SET_SELF_CHECK_IN_EXTENDED_ENABLED';

// Labels
export const SET_MODEL_LABEL_OTHER = 'SET_MODEL_LABEL_OTHER';
export const SET_MAKE_LABEL_OTHER = 'SET_MAKE_LABEL_OTHER';

// Quick Appointment
export const SET_QUICK_APPT_ENABLED = 'SET_QUICK_APPT_ENABLED';
export const SET_LOCALIZED_QUICK_APPT_SERVICE =
  'SET_LOCALIZED_QUICK_APPT_SERVICE';

// GUID
export const SET_GUID = 'SET_GUID';

// Mobile Phone
export const SET_SAVED_MOBILE = 'SET_SAVED_MOBILE';

// RECAPTCHA
export const SET_RECAPTCHA_TOKEN = 'SET_RECAPTCHA_TOKEN';



// WEBPACK FOOTER //
// ./src/store/reducers/userInteractions/actionTypes.js